import { render, staticRenderFns } from "./AfterDetail.vue?vue&type=template&id=67964008&scoped=true"
import script from "./AfterDetail.vue?vue&type=script&lang=js"
export * from "./AfterDetail.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./AfterDetail.vue?vue&type=style&index=0&id=67964008&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "67964008",
  "e6e4a0ea"
  
)

export default component.exports